import * as React from 'react';

import styled, { css } from 'styled-components';

export interface SongIconProps {
  className?: string;
  size?: number;
  dark?: boolean;
}

export const SongIcon: React.FC<SongIconProps> = (props) => (
  <svg
    className={props.className}
    width={props.size}
    height={props.size}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fillRule="evenodd"
      d="M19.43,.29c.36,.27,.57,.69,.57,1.14V14.28c0,1.87-1.21,3.52-2.99,4.08-1.78,.56-3.72-.09-4.8-1.61-1.08-1.52-1.04-3.57,.08-5.06,1.13-1.49,3.09-2.08,4.85-1.45V3.33l-8.57,2.49V15.71c0,.43-.04,.74-.1,.95-.39,1.74-1.82,3.05-3.58,3.3-1.76,.25-3.5-.61-4.36-2.17-.86-1.56-.67-3.49,.48-4.84,1.15-1.36,3.02-1.86,4.7-1.27V4.75c0-.63,.42-1.19,1.03-1.37L18.17,.06c.43-.13,.9-.04,1.26,.23Zm-3.71,12.57c-.79,0-1.43,.64-1.43,1.43s.64,1.43,1.43,1.43,1.43-.64,1.43-1.43-.64-1.43-1.43-1.43ZM2.86,15.71c0-.79,.64-1.43,1.43-1.43s1.43,.64,1.43,1.43-.64,1.43-1.43,1.43-1.43-.64-1.43-1.43Z"
    />
  </svg>
);

export default styled(SongIcon)`
  width: ${(props) => (props.size ? props.size : '40')}px;
  height: ${(props) => (props.size ? props.size : '40')}px;

  path {
    fill: ${(props) =>
      props.dark
        ? css`
            ${({ theme }) => theme.colors.iconBackground}
          `
        : css`
            ${({ theme }) => theme.colors.primary}
          `};
  }
`;
